import Vue from 'vue';
import Router from 'vue-router';
const _import = require('./_import_' + process.env.NODE_ENV); // 获取组件的方法

Vue.use(Router);
const originalPush = Router.prototype.push;
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
    // scrollBehavior(to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition;
    //     }
    //     return {
    //         x: 0,
    //         y: 0,
    //     };
    // },
    // scrollBehavior(to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition;
    //     } else {
    //         return { x: 0, y: 850 };
    //     }
    // },

    // mode: 'history',
    mode: 'hash',
    routes: [
        {
            path: '/',
            component: _import('/index2'),
        },
        {
            path: '/index',
            component: _import('/index'),
        },
        {
            path: '/index2',
            component: _import('/index2'),
        },
        {
            path: '/aboutus',
            component: _import('/aboutus'),
        },
        {
            path: '/workforce',
            component: _import('/workforce'),
        },
        {
            path: '/newscenter',
            component: _import('/newscenter'),
        },
        {
            path: '/newscentertopdetail',
            component: _import('/newscentertopdetail'),
        },
        {
            path: '/newscenterdetails1',
            component: _import('/newscenterdetails1'),
        },
        {
            path: '/product',
            component: _import('/product'),
        },
        {
            path: '/partywork',
            component: _import('/partywork'),
        },
        {
            path: '/talent',
            component: _import('/talent'),
        },
        {
            path: '/contact',
            component: _import('/contact'),
        },
        {
            path: '/details',
            component: _import('/details'),
        },
        {
            path: '/newDetails',
            component: _import('/newDetails'),
        },
        {
            path: '/party',
            component: _import('/party'),
        },
        {
            path: '/invite',
            component: _import('/invite'),
        },
        {
            path: '/boutique',
            component: _import('/boutique'),
        },
        {
            path: '/boutiquedetails',
            component: _import('/boutiquedetails'),
        },
        {
            path: '/structure',
            component: _import('/structure'),
        },
        {
            path: '/history',
            component: _import('/history'),
        },
        {
            path: '/culture',
            component: _import('/culture'),
        },
        {
            path: '/honor',
            component: _import('/honor'),
        },
        {
            path: '/horizondetails',
            component: _import('/horizondetails'),
        },
        {
            path: '/business',
            component: _import('/business'),
        },
        {
            path: '/businessdetails',
            component: _import('/businessdetails'),
        },

        {
            path: '/imgdetails',
            component: _import('/imgdetails'),
        },
        {
            path: '/dynamics',
            component: _import('/dynamics'),
        },
        {
            path: '/dynamicsdetails',
            component: _import('/dynamicsdetails'),
        },
        {
            path: '/videocenter',
            component: _import('/videocenter'),
        },
        {
            path: '/productdetail',
            component: _import('/productdetail'),
        },
        {
            path: '/planningdesign',
            component: _import('/planningdesign'),
        },
        {
            path: '/designdetail',
            component: _import('/designdetail'),
        },
        {
            path: '/esignIntroduction',
            component: _import('/esignIntroduction'),
        },
        {
            path: '/supervision',
            component: _import('/supervision'),
        },
        {
            path: '/supervisiondetail',
            component: _import('/supervisiondetail'),
        },
        {
            path: '/supervisionIntroduction',
            component: _import('/supervisionIntroduction'),
        },
        {
            path: '/EPCproject',
            component: _import('/EPCproject'),
        },
        {
            path: '/EPCprojectdetail',
            component: _import('/EPCprojectdetail'),
        },
        {
            path: '/EPCprojectIntroduction',
            component: _import('/EPCprojectIntroduction'),
        },
        ,
        {
            path: '/technological',
            component: _import('/technological'),
        },
        {
            path: '/videocenterdetails',
            component: _import('/videocenterdetails'),
        },
        {
            path: '/horizon',
            component: _import('/horizon'),
        },
        {
            path: '/tradunionwork',
            component: _import('/tradunionwork'),
        },
        {
            path: '/tradunionworkdetails',
            component: _import('/tradunionworkdetails'),
        },
        {
            path: '/leagueaffairswork',
            component: _import('/leagueaffairswork'),
        },
        {
            path: '/leagueaffairsworkdetails',
            component: _import('/leagueaffairsworkdetails'),
        },
        {
            path: '/zhongmingwelfarebank',
            component: _import('/zhongmingwelfarebank'),
        },
        {
            path: '/zhongmingwelfarebankdetails',
            component: _import('/zhongmingwelfarebankdetails'),
        },
        {
            path: '/partyworkdetails',
            component: _import('/partyworkdetails'),
        },
        {
            path: '/recruittalentsdetails',
            component: _import('/recruittalentsdetails'),
        },
        {
            path: '/boutiquedetails3d',
            component: _import('/boutiquedetails3d'),
        },
        {
            path: '/culturedetails',
            component: _import('/culturedetails'),
        },
        {
            path: '/technologicalConstructiondetails',
            component: _import('/technologicalConstructiondetails'),
        },
        {
            path: '/productdetailDetails',
            component: _import('/productdetailDetails'),
        },
        {
            path: '/Wholecountry',
            component: _import('/Wholecountry'),
        },
        {
            path: '/businesscooperation',
            component: _import('/businesscooperation'),
        },
        {
            path: '/recruittalents',
            component: _import('/recruittalents'),
        },

        {
            path: '/technologicalsd',
            component: _import('/technologicalsd'),
        },
        {
            path: '/technologicalConstruction',
            component: _import('/technologicalConstruction'),
        },
        {
            path: '/greenconstruction',
            component: _import('/greenconstruction'),
        },
        {
            path: '/constructionsite',
            component: _import('/constructionsite'),
        },
        {
            path: '/pieceInformation',
            component: _import('/pieceInformation'),
        },
        {
            path: '/projectStandardization',
            component: _import('/projectStandardization'),
        },
        {
            path: '/greenconstructiondetails',
            component: _import('/greenconstructiondetails'),
        },
        {
            path: '/constructionsitedetails',
            component: _import('/constructionsitedetails'),
        },
        {
            path: '/pieceInformationdetails',
            component: _import('/pieceInformationdetails'),
        },
        {
            path: '/projectStandardizationdetails',
            component: _import('/projectStandardizationdetails'),
        },
        {
            path: '/technologicaldetails',
            component: _import('/technologicaldetails'),
        },
        // 移动端路由
        {
            path: '/main',
            component: _import('/mobile/tabber/indexTabber'),
            children: [
                {
                    path: '/main/index2_mobile',
                    component: _import('/mobile/index2_mobile')
                },
                {
                    path: '/main/business_mobile',
                    component: _import('/mobile/business_mobile'),
                },
                {
                    path: '/main/boutique_mobile',
                    component: _import('/mobile/boutique_mobile')
                },
                {
                    path: '/main/businessdetails_mobile',
                    component: _import('/mobile/businessdetails_mobile')
                },
                {
                    path: '/main/boutiquedetails_mobile',
                    component: _import('/mobile/boutiquedetails_mobile')
                },
                {
                    path: '/main/boutiquedetails3d_mobile',
                    component: _import('/mobile/boutiquedetails3d_mobile')
                },
                {
                    path: '/main/details_mobile',
                    component: _import('/mobile/details_mobile')
                }
            ]
        },

        {
            path: '/m_aboutus',
            component: _import('/mobile/tabber/aboutusTabber'),
            children: [
                {
                    path: '/m_aboutus/aboutus_mobile',
                    component: _import('/mobile/aboutus_mobile')
                },
                {
                    path: '/m_aboutus/structure_mobile',
                    component: _import('/mobile/structure_mobile')
                },
                {
                    path: '/m_aboutus/history_mobile',
                    component: _import('/mobile/history_mobile')
                },
                {
                    path: '/m_aboutus/culture_mobile',
                    component: _import('/mobile/culture_mobile')
                },
                {
                    path: '/m_aboutus/culturedetails_mobile',
                    component: _import('/mobile/culturedetails_mobile')
                },
                {
                    path: '/m_aboutus/honor_mobile',
                    component: _import('/mobile/honor_mobile')
                }
            ]
        },
        {
            path: '/m_newscenter',
            component: _import('/mobile/tabber/newscenter'),
            children: [
                {
                    path: '/m_newscenter/group_mobile',
                    component: _import('/mobile/group_mobile')
                },
                {
                    path: '/m_newscenter/newscentertopdetail_mobile',
                    component: _import('/mobile/newscentertopdetail_mobile')
                },
                {
                    path: '/m_newscenter/newscenterdetails_mobile',
                    component: _import('/mobile/newscenterdetails_mobile')
                },
                {
                    path: '/m_newscenter/dynamics_mobile',
                    component: _import('/mobile/dynamics_mobile')
                },
                {
                    path: '/m_newscenter/dynamicsdetails_mobile',
                    component: _import('/mobile/dynamicsdetails_mobile')
                },
                {
                    path: '/m_newscenter/videocenter_mobile',
                    component: _import('/mobile/videocenter_mobile')
                },
                {
                    path: '/m_newscenter/horizon_mobile',
                    component: _import('/mobile/horizon_mobile')
                },
                {
                    path: '/m_newscenter/horizondetails_mobile',
                    component: _import('/mobile/horizondetails_mobile')
                }
            ]
        },
        {
            path: '/m_product',
            component: _import('/mobile/tabber/productTabber'),
            children: [
                {
                    path: '/m_product/product_mobile',
                    component: _import('/mobile/product_mobile')
                },
                {
                    path: '/m_product/productdetail_mobile',
                    component: _import('/mobile/productdetail_mobile')
                },
                {
                    path: '/m_product/productdetailDetails_mobile',
                    component: _import('/mobile/productdetailDetails_mobile')
                },
                {
                    path: '/m_product/planningdesign_mobile',
                    component: _import('/mobile/planningdesign_mobile')
                },
                {
                    path: '/m_product/designdetail_mobile',
                    component: _import('/mobile/designdetail_mobile')
                },
                {
                    path: '/m_product/esignIntroduction_mobile',
                    component: _import('/mobile/esignIntroduction_mobile')
                },
                {
                    path: '/m_product/supervision_mobile',
                    component: _import('/mobile/supervision_mobile')
                },
                {
                    path: '/m_product/supervisiondetail_mobile',
                    component: _import('/mobile/supervisiondetail_mobile')
                },
                {
                    path: '/m_product/supervisionIntroduction_mobile',
                    component: _import('/mobile/supervisionIntroduction_mobile')
                },
                {
                    path: '/m_product/epcproject_mobile',
                    component: _import('/mobile/EPCproject_mobile')
                },
                {
                    path: '/m_product/epcprojectdetail_mobile',
                    component: _import('/mobile/EPCprojectdetail_mobile')
                },
                {
                    path: '/m_product/epcprojectIntroduction_mobile',
                    component: _import('/mobile/EPCprojectIntroduction_mobile')
                }
            ]
        },
        {
            path: '/m_technological',
            component: _import('/mobile/tabber/technologicalTabber'),
            children: [
                {
                    path: '/m_technological/technological_mobile',
                    component: _import('/mobile/technological_mobile')
                },
                {
                    path: '/m_technological/technologicaldetails_mobile',
                    component: _import('/mobile/technologicaldetails_mobile')
                },
                {
                    path: '/m_technological/technologicalConstruction_mobile',
                    component: _import('/mobile/technologicalConstruction_mobile')
                },
                {
                    path: '/m_technological/technologicalConstructiondetails_mobile',
                    component: _import('/mobile/technologicalConstructiondetails_mobile')
                },
                {
                    path: '/m_technological/greenconstruction_mobile',
                    component: _import('/mobile/greenconstruction_mobile')
                },
                {
                    path: '/m_technological/greenconstructiondetails_mobile',
                    component: _import('/mobile/greenconstructiondetails_mobile')
                },
                {
                    path: '/m_technological/constructionsite_mobile',
                    component: _import('/mobile/constructionsite_mobile')
                },
                {
                    path: '/m_technological/constructionsitedetails_mobile',
                    component: _import('/mobile/constructionsitedetails_mobile') 
                },
                {
                    path: '/m_technological/pieceInformation_mobile',
                    component: _import('/mobile/pieceInformation_mobile')
                },
                {
                    path: '/m_technological/pieceInformationdetails_mobile',
                    component: _import('/mobile/pieceInformationdetails_mobile')
                },
                {
                    path: '/m_technological/projectStandardization_mobile',
                    component: _import('/mobile/projectStandardization_mobile')
                },
                {
                    path: '/m_technological/projectStandardizationdetails_mobile',
                    component: _import('/mobile/projectStandardizationdetails_mobile')
                }
            ]
        },
        {
            path: '/m_partywork',
            component: _import('/mobile/tabber/partyworkTabber'),
            children: [
                {
                    path: '/m_partywork/partywork_mobile',
                    component: _import('/mobile/partywork_mobile')
                },
                {
                    path: '/m_partywork/partyworkdetails_mobile',
                    component: _import('/mobile/partyworkdetails_mobile')
                },
                {
                    path: '/m_partywork/tradunionwork_mobile',
                    component: _import('/mobile/tradunionwork_mobile')
                },
                {
                    path: '/m_partywork/tradunionworkdetails_mobile',
                    component: _import('/mobile/tradunionworkdetails_mobile')
                },
                {
                    path: '/m_partywork/leagueaffairswork_mobile',
                    component: _import('/mobile/leagueaffairswork_mobile')
                },
                {
                    path: '/m_partywork/leagueaffairsworkdetails_mobile',
                    component: _import('/mobile/leagueaffairsworkdetails_mobile')
                },
                {
                    path: '/m_partywork/zhongmingwelfarebank_mobile',
                    component: _import('/mobile/zhongmingwelfarebank_mobile')
                },
                {
                    path: '/m_partywork/zhongmingwelfarebankdetails_mobile',
                    component: _import('/mobile/zhongmingwelfarebankdetails_mobile')
                },
            ]
        },
        {
            path: '/m_contact',
            component: _import('/mobile/tabber/contactTabber'),
            children: [
                {
                    path: '/m_contact/wholecountry_mobile',
                    component: _import('/mobile/wholecountry_mobile'),
                },
                {
                    path: '/m_contact/businesscooperation_mobile',
                    component: _import('/mobile/businesscooperation_mobile'),
                },
                {
                    path: '/m_contact/recruittalents_mobile',
                    component: _import('/mobile/recruittalents_mobile'),
                },
                {
                    path: '/m_contact/recruittalentsdetails_mobile',
                    component: _import('/mobile/recruittalentsdetails_mobile')
                }
            ],
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js